import axiosInstance from "../utils/axios";

// TODO: this should be wrapped with try/catch
// THE SAME MUST BE DONE FOR ALL CALLS THAT ARE BEING USED BY REACT QUERY
// AS PER REQUIREMENT OF WHAT IT WILL BE NEEDED FOR ERROR HANDLING
export const getAllPublishers = async () => {
  const res = await axiosInstance.get("api/publisher/all", {
    withCredentials: true,
  });
  return res?.data;
};
